import { IncidentRulesOpen } from "components/files/modals/RulesModel";
import { CustomComponentProps } from "utils/types/generalTypes";

export type RuleItemProps = CustomComponentProps & {
    item: IncidentRulesOpen;
    openRule: (attr: IncidentRulesOpen) => void;
    close: () => void;
};
const RuleItem = ({
    item,
    openRule,
    close,
    className,
    style
}: RuleItemProps) => {
    // const [showAns, setShowAns] = useState(false);
    return (
        <div
            className={`rule-item mb-20 ${item.isOpened ? "show-rule-ans" : ""} ${className}`}
            style={style}
        >
            <div className="rule-item-q mb-10 white-text d-flex flex-j-between flex-a-center gap-5">
                <h3>{item.question}</h3>
                <div
                    className={`rotating-plus-div p-relative cursor-pointer`}
                    onClick={() => (item.isOpened ? close() : openRule(item))}
                >
                    <div className="rotating-plus-v"></div>
                    <div className="rotating-plus-h"></div>
                </div>
            </div>
            <div className={`rule-item-ans `}>
                <p
                    className="momeento-p light-grey-text"
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                >
                    {/* {item.answer} */}
                </p>
            </div>
        </div>
    );
};

export default RuleItem;
